import api from "@/api/api.js";
import ArchiveHint from "./ArchiveHint.jsx";

const DigitalSignatureDownload = ({
  companyId,
  signatureId,
  fileName = "firma.7z",
}) => {
  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const response = await api.get(
        `/companies/${companyId}/digitalSignature/${signatureId}/download`,
        { responseType: "blob" },
      );
      const cd = response.headers?.["content-disposition"] || "";
      const match = /filename="?([^"]+)"?/.exec(cd);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", match?.[1] || fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando la firma:", error);
    }
  };

  return (
    <span className="d-inline-flex align-items-center">
      <a href="#" onClick={handleDownload}>
        <i className="bi bi-download me-1" />
        {fileName}
      </a>
      <ArchiveHint />
    </span>
  );
};

export default DigitalSignatureDownload;
